'use strict'

const once = require('once')
const ConcatStream = require('concat-stream')
const SendFilesStream = require('./send-files-stream')

module.exports = (send, path) => {
  const sendFilesStream = SendFilesStream(send, path)
  return (file, options, _callback) => {
    const callback = once(_callback)
    const stream = sendFilesStream(options)
    const concat = ConcatStream((results) => callback(null, results))
    stream.once('error', callback)
    stream.pipe(concat)
    stream.write(file)
    stream.end()
  }
}



//////////////////
// WEBPACK FOOTER
// ./src/utils/send-one-file-multiple-results.js
// module id = 89
// module chunks = 0